// extracted by mini-css-extract-plugin
export default {"package-list-container":"InboundAwb_package-list-container__lvtLT","prefix-label":"InboundAwb_prefix-label__9QKMp"};